module.exports = __webpack_public_path__ + "static/media/news-dan-pickett.a423c790.jpg";